import { useState } from 'react';
import { Flex, Text } from '@backstage/ui';

import { CheckDetailDialog } from './CheckDetailDialog';
import type { CheckRow } from '../../hooks/useProjectScorecard';
import { ChecksTable } from './ChecksTable';
import { useProjectScorecard } from '../../hooks/useProjectScorecard';
import { ScorecardsFilterProvider } from './ScorecardsFilterContext';
import { EntityKpiSection } from './EntityKpiSection';

export const ProjectScorecards = () => {
  const { rows, isLoading, error } = useProjectScorecard();
  const [selectedRow, setSelectedRow] = useState<CheckRow | null>(null);

  if (error) {
    return (
      <Text as="p" color="danger">
        Failed to load scorecards: {error.message}
      </Text>
    );
  }

  return (
    <ScorecardsFilterProvider>
      <Flex direction="column" p="4">
        <EntityKpiSection rows={rows} isLoading={isLoading} />
        <ChecksTable
          rows={rows}
          isLoading={isLoading}
          onRowClick={setSelectedRow}
        />
        <CheckDetailDialog
          row={selectedRow}
          onClose={() => setSelectedRow(null)}
        />
      </Flex>
    </ScorecardsFilterProvider>
  );
};
